<template>
  <!-- Trigger Button -->
  <button
    id="dev-tools-button"
    @click="openOverlay"
    class="fixed top-0 right-96 z-50 bg-anymic-gold hover:bg-anymic-gold/80 text-white text-sm px-4 py-2 rounded shadow-lg"
  >
    🛠
  </button>

  <!-- Overlay -->
  <transition name="fade">
    <div
      v-if="isOverlayVisible"
      class="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex justify-end"
    >
      <!-- Click-outside area -->
      <div class="absolute inset-0" @click="closeOverlay" />

      <!-- Drawer -->
      <transition name="slide-in-right">
        <div class="bg-anymic-darkblue p-4 w-full max-w-4xl h-full z-10 shadow-xl rounded-l-2xl overflow-y-auto">
          <div class="flex justify-between items-center mb-4">
            <h3 class="text-lg font-semibold text-white">Developer Tools</h3>
            <button @click="closeOverlay" class="bg-anymic-blue text-white px-3 py-1 rounded shadow hover:bg-anymic-blue/80 text-sm">Close</button>
          </div>

          <!-- Your DevTools Component -->
          <InspectStore></InspectStore>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import InspectStore from "@/views/my/dev/components/InspectStore.vue"; // adjust path as needed

const isOverlayVisible = ref(false)

function openOverlay() {
  isOverlayVisible.value = true
  document.body.classList.add('overflow-hidden')
  document.documentElement.style.overflow = 'hidden'
}

function closeOverlay() {
  isOverlayVisible.value = false
  document.body.classList.remove('overflow-hidden')
  document.documentElement.style.overflow = ''
}

function handleEscape(e: KeyboardEvent) {
  if (e.key === 'Escape') closeOverlay()
}

onMounted(() => {
  window.addEventListener('keydown', handleEscape)
})
onUnmounted(() => {
  window.removeEventListener('keydown', handleEscape)
})
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.slide-in-right-enter-active,
.slide-in-right-leave-active {
  transition: transform 0.3s ease;
}
.slide-in-right-enter-from,
.slide-in-right-leave-to {
  transform: translateX(100%);
}
</style>
